@if (showCelebrationOverlay()) {
  <div
    class="fixed inset-0 z-10000 flex items-center justify-center bg-black/80 backdrop-blur-sm animate-fade-in p-6"
  >
    <div
      class="flex flex-col gap-8 items-center justify-center w-full max-w-2xl text-center text-gray-50"
    >
      <h1 class="text-4xl font-bold" i18n>Daily tasks completed!</h1>
      <img
        src="tiger-7.png"
        alt="Daily tasks completed"
        class="w-11/12 max-w-[350px] object-contain drop-shadow-lg"
      />
      <button
        (click)="dismiss()"
        class="flex items-center justify-center h-24 w-24 bg-primary-500 hover:bg-primary-600 disabled:bg-gray-400 text-white rounded-full font-medium transition-colors duration-200 shadow-lg hover:shadow-xl disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
      >
        <i class="far fa-arrow-right text-3xl!"></i>
      </button>
    </div>
  </div>
}

@if (showFreePracticeMessage()) {
  <div
    class="fixed inset-0 z-10000 flex items-center justify-center bg-black/80 backdrop-blur-sm animate-fade-in p-6"
  >
    <div
      class="flex flex-col gap-8 items-center justify-center w-full max-w-2xl text-center text-gray-50"
    >
      <h1 class="text-4xl font-bold" i18n>Free Practice Mode</h1>
      <p class="text-lg text-gray-200" i18n>
        You&apos;ve completed today&apos;s required exercises. You can continue
        practicing for the rest of the day!
      </p>
      <img
        src="tiger-7.png"
        alt="Free practice mode"
        class="w-11/12 max-w-[350px] object-contain drop-shadow-lg"
      />
      <button
        (click)="dismiss()"
        class="flex items-center justify-center h-24 w-24 bg-primary-500 hover:bg-primary-600 disabled:bg-gray-400 text-white rounded-full font-medium transition-colors duration-200 shadow-lg hover:shadow-xl disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
      >
        <i class="far fa-arrow-right text-3xl!"></i>
      </button>
    </div>
  </div>
}
